import image_model from "../../../Assets/image_divider_woman.png";
import { Link } from "react-router-dom";
import "./DividerWomen.css";
import { useInView } from "../../../Hooks/useInView";

export const DividerWomen = () => {
  const { ref, isVisible } = useInView({ threshold: 0.5 });

  return (
    <div
      ref={ref}
      className={`divider-women ${isVisible ? "divider-women--visible" : ""}`}
    >
      <div className="divider-women-info">
        <div className="divider-women-content">
          <h2>Popular Amongst Women</h2>
          <p>Discover the latest trends in women's fashion, curated for style and comfort.</p>
          <Link to="/women" className="divider-women-button">
            Shop Now
          </Link>
        </div>
        <Link to="/women" className="divider-women-image">
          <div className="model-mask">
            <img src={image_model} alt="Women's fashion model" />
          </div>
        </Link>
      {/* shapes ... */}
      <div className="shape s1"></div>
      <div className="shape s2"></div>
      <div className="shape s3"></div>
      <div className="shape s4"></div>
      <div className="shape s5"></div>
      <div className="shape-opaque s6"></div>
      <div className="shape s7"></div>
      <div className="shape s8"></div>

      </div>
    </div>
  );
};
